<template>
  <a-form-model
    layout="vertical"
  >
    <a-form-model-item label="卷帘尺寸">
      <a-input prefix="宽" suffix="厘米" name="width" v-model.number="properties.width"
        @blur="changeWidth"
        @keypress.enter="(e)=>{e.target.blur()}"
      />
      <a-input prefix="高" suffix="厘米" name="height" v-model.number="properties.height"
        @blur="changeHeight"
        @keypress.enter="(e)=>{e.target.blur()}"
      />
    </a-form-model-item>
    <a-form-model-item label="面料选择">
      <a-select default-value="" v-model="properties.mianliao.value" @change="changeMianliao" name="mianliao">
        <a-select-option v-for="option in fabricOptions"
                        :key="option.value"
                        :value="option.value">
          {{option.label}}
        </a-select-option>
      </a-select>
      <a-input placeholder="自定义面料"
        v-model="properties.mianliao.other"
        v-show="showCustomMianliao"
        @change="changeProperty"
      />
    </a-form-model-item>
    <a-form-item label="单双面选择">
      <a-select default-value="单面印" v-model="properties.face" @change="changeFace()" name="face">
        <a-select-option value="单面印">单面印</a-select-option>
        <a-select-option value="双面印正面">双面印正面</a-select-option>
        <a-select-option value="双面印反面">双面印反面</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-model-item label="卷帘头预留">
      <a-input suffix="厘米" v-model.number="properties.curtainHead" @change="changeCurtainHead"/>
    </a-form-model-item>
    <a-form-model-item label="底色">
      <a-input type="color" v-model="properties.bgColor" @change="changeColor"></a-input>
    </a-form-model-item>
    <a-form-model-item label="备注">
      <a-input v-model="properties.note" @change="changeProperty"/>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
export default {
  components: {
  },
  props: ['params'],
  data () {
    return {
      fabricOptions: window.FABRIC_OPTIONS,
      properties: this.params || {
        width: 100,
        height: 100,
        mianliao: {
          value: 'other',
          other: ''
        },
        face: '单面印',
        curtainHead: 15,
        bgColor: '#ffffff',
        note: ''
      },
      // 拷贝, 保存属性改变前的值
      propertiesCopy: {}
    }
  },
  computed: {
    showCustomMianliao () {
      return this.properties.mianliao.value === 'other'
    }
  },
  created () {
    this.copyProperties()
  },
  methods: {
    changeProperty () {
      this.$emit('propertyChanged', this.properties)
    },
    changeSize () {
      this.$emit('sizeChanged', this.properties)
    },
    changeWidth (e) {
      this.validateWidth()
      this.adjustWidth(e)
      this.copyProperties()
      this.$emit('sizeChanged', this.properties)
    },
    changeHeight (e) {
      this.validateHeight()
      this.adjustHeight(e)
      this.copyProperties()
      this.$emit('sizeChanged', this.properties)
    },
    changeCurtainHead () {
      this.$emit('curtainHeadChanged', this.properties)
    },
    changeColor () {
      this.$emit('colorChanged', this.properties)
    },
    changeMianliao () {
      // 特殊面料自动修改高度
      this.adjustHeight()
      this.copyProperties()
      this.$emit('sizeChanged', this.properties)
      this.$emit('propertyChanged', this.properties)
    },
    changeFace () {
      this.adjustWidth()
      this.copyProperties()
      this.$emit('sizeChanged', this.properties)
      this.$emit('propertyChanged', this.properties)
    },
    // 验证
    validateWidth () {
      const value = this.properties.width
      if (value < 20 || (value >= 300 && this.properties.height >= 300)) {
        this.$warning({
          title: '提示',
          content: '宽度和高度都必须大于20, 且不能同时大于300'
        })
      }
    },
    validateHeight () {
      const value = this.properties.height
      if (value < 20 || (value >= 300 && this.properties.width >= 300)) {
        this.$warning({
          title: '提示',
          content: '宽度和高度都必须大于20, 且不能同时大于300'
        })
      }
    },
    // 自动修改宽度
    adjustWidth (e) {
      // 修改宽度
      if (e !== undefined &&
        e.target.name === 'width' &&
        this.properties.width !== this.propertiesCopy.width &&
        this.properties.face.startsWith('双面印')) {
        this.properties.width += 2
      } else {
        // 修改单双面印
        if (this.properties.face.startsWith('双面印') && !this.propertiesCopy.face.startsWith('双面印')) {
          this.properties.width += 2
        } else if (this.propertiesCopy.face.startsWith('双面印') && !this.properties.face.startsWith('双面印')) {
          this.properties.width -= 2
        }
      }
    },
    // 自动调整高度
    adjustHeight (e) {
      if (e !== undefined &&
        e.target.name === 'height' &&
        this.properties.height !== this.propertiesCopy.height &&
        this.properties.mianliao.value === '香格里拉帘') {
        this.properties.height += 10
      } else if (this.properties.mianliao.value === '香格里拉帘' && this.propertiesCopy.mianliao.value !== '香格里拉帘') {
        this.properties.height += 10
      } else if (this.propertiesCopy.mianliao.value === '香格里拉帘' && this.properties.mianliao.value !== '香格里拉帘') {
        this.properties.height -= 10
      }
    },
    copyProperties () {
      this.propertiesCopy = JSON.parse(JSON.stringify(this.properties))
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/design/CurtainProperty.vue